import { render, staticRenderFns } from "./SQLrecords.vue?vue&type=template&id=2d77c251&scoped=true&"
import script from "./SQLrecords.vue?vue&type=script&lang=js&"
export * from "./SQLrecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d77c251",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d77c251')) {
      api.createRecord('2d77c251', component.options)
    } else {
      api.reload('2d77c251', component.options)
    }
    module.hot.accept("./SQLrecords.vue?vue&type=template&id=2d77c251&scoped=true&", function () {
      api.rerender('2d77c251', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/SQLrecords.vue"
export default component.exports